// TODO: Abstract to utils file structure

import { addMonths, subYears, format } from 'date-fns';

export const today = new Date();
export const minDOB = subYears(today, 120);
export const maxDOB = new Date(subYears(today, 18).setHours(0, 0, 0, 0));
export const minStartDate = new Date(today.setHours(0, 0, 0, 0));
export const maxStartDate = addMonths(today, 2);

export function dateToStringConverter(date: Date): string {
  return format(date, 'dd/MM/yyyy');
}

export function validateDateOfBirth(providateDate: string): string | null {
  const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
  if (!regex.test(providateDate)) {
    return 'Please use the format: dd/mm/yyyy';
  }
  const dateArray = providateDate.split('/');
  const dob = new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`);
  if (dob.toString() === 'Invalid Date') {
    return 'Incorrect date format';
  }
  if (dob < minDOB) {
    return 'Please enter a date lower than 120 years';
  }
  if (dob >= maxDOB) {
    return 'You must be 18 years or older';
  }
  return null;
}

export function validatePhoneNumber(phoneNumber: string): boolean {
  const cleanPhoneNumber = phoneNumber.replace(/\s/g, '');
  return /^(?:04|05|02|03|07|08|1300|13)\d{8,15}$/.test(cleanPhoneNumber);
}

const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

export function isValidateAbn(abn: string): boolean {
  if (!abn) {
    return false;
  }

  // check if length is 11 digits
  if (abn.length !== 11) {
    return false;
  }

  // apply ato check method
  let sum = 0;
  weights.forEach((weight, position) => {
    const digit = Number(abn[position]) - (position ? 0 : 1);
    sum += weight * digit;
  });

  const checksum = sum % 89;

  return checksum === 0;
}
